import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { formVersionQueryKeys } from './keys';

type TemplateFileUrlResponse = { downloadUrl: string };

export const useGetTemplateFileUrl = (formVersionId: string) => {
  const client = useClient();

  const result = useQuery<TemplateFileUrlResponse, Error>({
    queryKey: [formVersionQueryKeys.resource, formVersionId, 'template-file-url'] as const,
    queryFn: () => client.get(`form-version/${formVersionId}/template-file-url`).json<TemplateFileUrlResponse>(),
    enabled: false,
    staleTime: 60_000,
  });

  return {
    getTemplateFileUrl: result.refetch,
    isLoading: result.isLoading,
  };
};
